import CardPlaceholder from '~/components/ui/CardPlaceholder.vue';
import { useGetTranslations } from '@/composables/useGetTranslations';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
export default defineComponent({
  name: 'SearchResults',
  components: {
    CardPlaceholder: CardPlaceholder,
    AzIcon: AzIcon
  },
  props: {
    term: {
      type: String,
      default: ''
    }
  },
  setup: function setup() {
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var amountOfPlaceholders = 2;
    onMounted(function () {
      // To avoid SSR and CSR differences when using isMobile (which is always false on SSR)
      // set the number of card when component is mounted
      amountOfPlaceholders = isMobile.value ? 2 : 3;
    });
    return {
      translate: translate,
      amountOfPlaceholders: amountOfPlaceholders
    };
  }
});